/** @jsxImportSource @emotion/react */
import React from 'react'
import CouponListPage from './page/CouponListPage'

type CouponsPageProps = {
  scheduleId?: string
  organizationId?: string
  currencyCode?: string
  openCreateModalRef?: React.MutableRefObject<(() => void) | null>
}

export default function CouponsPage({
  scheduleId,
  organizationId,
  currencyCode,
  openCreateModalRef,
}: CouponsPageProps) {
  return (
    <CouponListPage
      scheduleId={scheduleId}
      organizationId={organizationId}
      currencyCode={currencyCode}
      openCreateModalRef={openCreateModalRef}
    />
  )
}
